import { useState as a, useEffect as c } from "react";
import "react/jsx-runtime";
import { getRelativeTimeUpdateInfo as n } from "../../utils/getRelativeTimeUpdateInfo/index.js";
import "../../theme/spacing.js";
function g(r, o = !0) {
  const [u, i] = a(
    () => {
      const { value: t, unit: e } = n(r);
      return [t, e];
    }
  );
  return c(() => {
    if (!o)
      return;
    let t;
    const e = () => {
      const { value: m, unit: s, nextIntervalMs: f } = n(r);
      i([m, s]), t = setTimeout(e, f);
    };
    return e(), () => clearTimeout(t);
  }, [o, r]), u;
}
export {
  g as useTimeAgo
};
